import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import Layout from "./components/Layout";
import SiteLayout from "./components/SiteLayout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import NewCertificate from "./pages/NewCertificate";
import Records from "./pages/Records";
import Templates from "./pages/Templates";
import Settings from "./pages/Settings";
import Designer from "./pages/Designer";
import Fonts from "./pages/Fonts";
import Website from "./pages/Website";
import Verify from "./pages/Verify";
import SiteHome from "./pages/SiteHome";
import SiteCourses from "./pages/SiteCourses";
import SiteCourseDetail from "./pages/SiteCourseDetail";
import SiteAbout from "./pages/SiteAbout";
import SiteContact from "./pages/SiteContact";
import { AuthProvider, useAuth } from "./lib/auth";

function Protected({ children }) {
  const { user, checking } = useAuth();
  if (checking) {
    return (
      <div className="min-h-screen grid place-items-center text-slate-400 text-sm">
        Loading…
      </div>
    );
  }
  if (!user?.token) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/verify/:key" element={<Verify />} />
            {/* public institute website */}
            <Route element={<SiteLayout />}>
              <Route path="/" element={<SiteHome />} />
              <Route path="/courses" element={<SiteCourses />} />
              <Route path="/courses/:cid" element={<SiteCourseDetail />} />
              <Route path="/about" element={<SiteAbout />} />
              <Route path="/contact" element={<SiteContact />} />
            </Route>
            {/* admin console */}
            <Route
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route path="/admin" element={<Dashboard />} />
              <Route path="/admin/new" element={<NewCertificate />} />
              <Route path="/admin/new/:sid" element={<NewCertificate />} />
              <Route path="/admin/records" element={<Records />} />
              <Route path="/admin/templates" element={<Templates />} />
              <Route path="/admin/designer" element={<Designer />} />
              <Route path="/admin/fonts" element={<Fonts />} />
              <Route path="/admin/website" element={<Website />} />
              <Route path="/admin/settings" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
